import React, { FC } from 'react'
import Modal from 'components/SA/Modal/v2'
import styles from '../CollectionDetails.module.scss'
import { deleteCollection } from 'apis/private/collection'
import useFlashMessage from 'hooks/useFlashMessage'

export const DELETE_COLLECTION_MODAL = 'deleteCollection'

type DeleteCollectionModalProps = {
  onClose: () => void
  idUserCollection: number
  collectionsUrl: string
}

const DeleteCollectionModal: FC<DeleteCollectionModalProps> = ({
  onClose,
  idUserCollection,
  collectionsUrl,
}) => {
  const { showErrorMessage, showSuccessMessage } = useFlashMessage()

  const handleDeleteCollection = async () => {
    const apiResponse = await deleteCollection(idUserCollection)
    const { success } = apiResponse

    if (!success) {
      showErrorMessage('Problem deleting collection')
    } else {
      showSuccessMessage('Successfully deleted collection')
      window.location.href = collectionsUrl
    }
  }

  return (
    <Modal
      name={DELETE_COLLECTION_MODAL}
      onCloseModal={onClose}
      layout='standard'
      // styleOverride={styles.authModal}
      isCloseButtonVisible
    >
      <div className={styles.deleteCollectionModalWrapper}>
        <h3>Are you sure you want to delete this collection?</h3>

        <div className={styles.buttonsContainer}>
          <button className='defaultButtonOutlined' onClick={onClose}>
            CANCEL
          </button>

          <button className='defaultButton' onClick={handleDeleteCollection}>
            OK
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteCollectionModal
